import { Attributes } from '@leverege/ui-attributes';
import Types from "../../constants/Types.js";
import FirmwareApplicationId from "../builders/FirmwareApplicationId.js";
export default FirmwareApplicationId({
  objectType: Types.firmwareRelease,
  creatable: true,
  editorProps: {
    getQuery: (data, cxt) => {
      // assume its in targets and targets all have same device type id?
      const {
        targets,
        deviceType
      } = cxt;
      let deviceTypeId;
      if (deviceType) {
        deviceTypeId = Attributes.get('id', Types.deviceType, deviceType);
      } else if (targets?.[0].type === Types.deviceType) {
        deviceTypeId = Attributes.get('id', targets?.[0].type, targets?.[0].data);
      } else {
        deviceTypeId = Attributes.get('deviceTypeId', targets?.[0].type, targets?.[0].data);
      }
      return {
        deviceTypeId
      };
    }
  }
});